var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { style: { display: "block" }, attrs: { xs: "12" } },
        _vm._l(_vm.product.Images, function (img) {
          return _c("div", {
            key: img.ID,
            staticClass: "img",
            style: { backgroundImage: "url(" + img.getFileUrl() + ")" },
          })
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }